/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaValue from './AqaValue';

/**
 * The AqaVectorValues model module.
 * @module model/AqaVectorValues
 * @version v0
 */
export default class AqaVectorValues {
  /**
   * Constructs a new <code>AqaVectorValues</code>.
   * @alias module:model/AqaVectorValues
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaVectorValues</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaVectorValues} obj Optional instance to populate.
   * @return {module:model/AqaVectorValues} The populated <code>AqaVectorValues</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaVectorValues();
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('originalPosition'))
        obj.originalPosition = ApiClient.convertToType(data['originalPosition'], 'Number');
      if (data.hasOwnProperty('values'))
        obj.values = ApiClient.convertToType(data['values'], [AqaValue]);
    }
    return obj;
  }
}

/**
 * @member {Number} position
 */
AqaVectorValues.prototype.position = undefined;

/**
 * @member {Number} originalPosition
 */
AqaVectorValues.prototype.originalPosition = undefined;

/**
 * @member {Array.<module:model/AqaValue>} values
 */
AqaVectorValues.prototype.values = undefined;

